// extracted by mini-css-extract-plugin
export default {"container":"TargetOfCondition_container__Kw4Dz","tableCard":"TargetOfCondition_tableCard__4O4X-"};